import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform } from 'ionic-angular';
import { B01D02SalesPaymentPage } from '../b01-d02-sales-payment/b01-d02-sales-payment';
import { AlertController } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
import { Storage } from '@ionic/storage';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { B08PrinterPage } from '../b08-printer/b08-printer';

/**
 * Generated class for the B01SalesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface branchInfo{
  BRANCH_ID: number;
};

interface inventoryInfo{
};
interface inventoryLevelInfo{
  BRANCH_ID: number;
  INVENTORY_ID: number;
  QUANTITY: number;
  VALUE: number;
};
interface cardInfo{
  CARD_ID: number;
  CARD_NO: number;
  BALANCE: string;
};

interface paymentTypeInfo {
	PAYMENT_TYPE_ID: number;
	TYPE: string;
	AUTHORIZE: string;
	PAYMENT_TYPE_ACTIVE: string;
}

interface paymentTypeInfo {
  AMOUNT_TENDER: number;
  AMOUNT_CHANGE: number;
  CORP_CARD_NO: string;
  AUTH_NO: string;
  DATETIME: string;
//  PAYMENT_TYPE_ID: string;
  PAYMENT_SUB_TYPE_ID: string;
  CARD_CORP: string;
  CORP_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b01-sales',
  templateUrl: 'b01-sales.html',
})

export class B01SalesPage {
  public qty_value:any ="";
  oil_quantity:string="";
  inventroy_id:any;
  inventory_type:any;
  public oil_type:string="";
  public oil_price:string="";
  tax_perc: number = 10;
  total_tax: number = 0;
  item_tax: number = 0;
  
  discount:number=0;
  public so_total_price:number=0.00;
  public total_sub:number=0.00;
  public subTotal:number=0.00;
  Layby_SO_ID: any = 0;

  public item_data = [];  
  public i=0;

  //BRANCH
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  inventory1 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};
  inventory2 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};
  inventory3 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};
  overlayHidden: boolean = true;
  
  overlayHidden2: boolean = true;
  userGrpId: any;
  loading: any;
  Status: any;
  public errorMessage: any = "";
  branchID: any;

  //Sales Data
  SOL_Array = [];
  PAYMENT_Array = [];
  DATA_Array = [];
  userId: any;
  userRunNo: number =0;
  SERVERDATE: any;
  myDate: string = new Date().toISOString();
  solData = { SOL_DESC:'', QTY:'', UNIT_PRICE:'', DISC_PERC:'',
              TAX_PERC:'', TOTAL_TAX:'', SOL_TOTAL:'', GRAND_SOL_TOTAL: '',
              INVENTORY_ID:'',
            }  
  paymentData = { AMOUNT_TENDER:0, AMOUNT_CHANGE:'', CORP_CARD_NO:'', AUTH_NO:'',
                  DATETIME:'', PAYMENT_TYPE_ID:'',
                }
  paymentBalance:any;
  wantokCard: any = '';
  userBranchId:any;
  soLocalStorage= [];
  salesParam: any;
  screenBig: any;

  inventoryData= [];
  branchData=[];
  cardArr: cardInfo[] = [];
  inventoryLevelArr: inventoryLevelInfo[] = [];
  userData= [];
  SO_NO: string;
  temp_SO_NO: string;
  SO_USER_ID: string;
  SO_SO_NO: string;
  cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
              }
  tempcardData=[];
  tempLevelData=[];
  cardNo: any;
  CARD_ID:any;

  //for reprint function
  companyData = { COMPANY:'', LOGO:'', 
                  ADD1:'', ADD2:'', ADD3:'',
                  CONTACT_NO1:'', 
                  EMAIL:'',
                }
  userName: any;
  lastSalesData=[];
  companyInfo: any;
  userInfo: any;
  receiptInfo: any;
  receiptInfo2: any;
  paymentInfo: any;
  paymentInfo2: any;
  thankyouInfo: any;
  // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
  s_companyInfo: any;
  s_userInfo: any;
  s_receiptInfo: any;
  s_receiptInfo2: any;
  s_paymentInfo: any;
  s_paymentInfo2: any;
  s_thankyouInfo: any;
  // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
  LOCAL_SO_ID: any;
  paymentTypeData_Print= [];
  paymentTypeArr_Print: paymentTypeInfo[] = [];
  paymentTypeItems_Print: paymentTypeInfo[] = [];
  SOL_Array_Print = []
  PAYMENT_Array_Print = []
  DATA_Array_Print = {
    RunNo:0,
    DateTime:"",
    SOL_Total:0,
    Branch_ID:"",
    Card:"",
    Action_By:"",
    Status:"",
    Sales:[],
    Payment:[]
  }
  wantokCard_Print: any = '';
  date_Print: any;
  SO_NO_Print: any;
  userRunNo_Print:any;
  f_fleetPay: any;
  shortage: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl : AlertController,
              private alertController:AlertController, public serviceapi:ServiceApiProvider, public loadingCtrl: LoadingController,
              public servicegvariable:ServiceGvariableProvider, public platform: Platform, public storage: Storage,
              private barcodeScanner: BarcodeScanner, public plt: Platform) {

    if (this.platform.width() > 900) {
      this.screenBig = 'yes';
    } else {
      this.screenBig = 'no';
    }
//    this.checkInternet();                 //check internet connection
    this.userId = sessionStorage.getItem('userid');
    this.userGrpId = sessionStorage.getItem('usergroupid');

    //get from layby page
    this.salesParam = navParams.get('salesParam');
    if (this.salesParam == '2') {
      this.item_data = navParams.get('Link');
      this.so_total_price = navParams.get('total_Amount');
      this.total_sub = navParams.get('total_Sub');
      this.Layby_SO_ID = navParams.get('layby_SO_ID');
      this.i = this.item_data.length;
    }

    //MOI
    if (this.servicegvariable.InternetConnection == 'Online'){

      //load dummy to check internet connection 
      let tbl = ["INVENTORY"];
      let column = ["INVENTORY_ID"];
      let value = ["1"];

      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showonlineLoader();
      this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
        this.servicegvariable.InternetConnection = "Online";
        this.loading.dismiss();

        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["CORP_ID"];
        let fktbl = ["CORPORATE"];
        let fkkey = ["CORP_ID"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");
        this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
          this.Status = result["Message"];

          if (this.Status == "1" || this.Status == "4"){
            let Records = result["Records"];
            this.cardArr = Records;
            
            this.storage.get('cardData').then((data) => {
              this.tempcardData = data;
              if (data && data.length > 0) {
                for (let i=0; i<data.length; i++){
                    
                  let data = JSON.parse(this.tempcardData[i]);
                  for (let x=0; x<this.cardArr.length; x++){              //check if server balance is less than local 210320
                    let data2 = data.find(({ CARD_NO }) => CARD_NO === this.cardArr[x].CARD_NO)
                    if (parseFloat(this.cardArr[x].BALANCE) > data2.BALANCE){
                      this.cardArr[x].BALANCE = data2.BALANCE;             //so that dont overwrite actual local data
                    }
                  }
                  
                  let val8 = JSON.stringify(this.cardArr);
                  let array = [];
                  array.push(val8);
                  this.storage.set('cardData', array);                      //store card data in local
                }
              }
            });

            
            let tbl = ["USER"];
            let column = ["USER_ID"];
            let value1 = [this.userId];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value1,tblkey,fktbl,fkkey);
            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");

            this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
              this.Status = result["Message"];

              if (this.Status == "1"){
                let Records = result["Records"];
                this.userId = Records[0]["USER_ID"];
                this.temp_SO_NO = Records[0]["USER_RUNNO"];
                this.SO_USER_ID = this.pad_with_zeroes(this.userId, 4);
                this.SO_SO_NO = this.pad_with_zeroes(this.temp_SO_NO, 10);                //add zero infront to make it 10 digit
                this.SO_NO = 'S' + this.SO_USER_ID + 'A' + this.SO_SO_NO;

                this.storage.get('userData').then((data) => {
                  this.userData = data;
                  if (data && data.length > 0) {
                    for (let i=0; i<data.length; i++){
                        
                      let data = JSON.parse(this.userData[i]);
                      for (let i=0; i<data.length; i++){
                        if (this.userId == data[i].USER_ID){
                          /* data[i].USER_RUNNO = this.userRunNo; */
                        }
                      }
                      let val = JSON.stringify(data);
                      let array = [];
                      array.push(val);
                      this.storage.set('userData', array);                //store group access arr
                    }
                  }
                });

                let tbl = ["All"];
                let column = ["All"];
                let value = ["All"];
                
                let tblkey = ["BRANCH_ID", "INVENTORY_ID"];
                let fktbl = ["BRANCH", "INVENTORY"];
                let fkkey = ["BRANCH_ID", "INVENTORY_ID"];

                let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
                let mydata = Object.assign(jsonitem);
                let json_data = this.serviceapi.json_readdata(mydata,"1");

                this.serviceapi.readdata(json_data,"INVENTORY_LEVEL","1","1").then((result) => {
                  this.Status = result["Message"];
                  if (this.Status == "1" || this.Status == "4"){
                    let Records = result["Records"];
                    this.inventoryLevelArr = Records;             //get inventory level and keep in local for checking during sales

                    this.storage.get('inventoryLevelData').then((data) => {
                      this.tempLevelData = data;
                      if (data && data.length > 0) {
                        for (let i=0; i<data.length; i++){
                            
                          let data = JSON.parse(this.tempLevelData[i]);
                          for (let x=0; x<this.inventoryLevelArr.length; x++){              //check if server balance is less than local
                            let data2 = data.find(({ INVENTORY_ID }) => INVENTORY_ID === this.inventoryLevelArr[x].INVENTORY_ID);
                            if ((this.inventoryLevelArr[x].QUANTITY) > data2.QUANTITY){
                              this.inventoryLevelArr[x].QUANTITY = data2.QUANTITY;             //so that dont overwrite actual local data
                            }
                          }
                          
                          let val8 = JSON.stringify(this.inventoryLevelArr);
                          let array = [];
                          array.push(val8);
                          this.storage.set('inventoryLevelData', array);                      //store card data in local
                        }
                      }
                    });
                  }
                }, (err) => {
                });
              }
            }, (err) => {
            });
          }
        }, (err) => {
          /* this.errorMessage = "Loading Error. Please try again."; */
        });

        if(sessionStorage.getItem('userbranchid') !=  "null")
        {
          this.branchID = sessionStorage.getItem('userbranchid');
              let tbl = ["BRANCH"];
              let column = ["BRANCH_ID"];
              let value = [this.branchID];

              let tblkey = ["No"];
              let fktbl = ["No"];
              let fkkey = ["No"];

              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");

              this.showLoader();
              this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
                
                this.Status = result["Message"];
                if (this.Status == '1'){
                  
                  let Records = result["Records"];
                  this.branchArr = Records;
                  this.branchItems = this.branchArr;
                
                  let tbl = ["INVENTORY","INVENTORY"];
                  let column = ["BRANCH_ID","INVENTORY_ACTIVE"];
                  let value = [this.branchID,"YES"];
          
                  let tblkey = ["No"];
                  let fktbl = ["No"];
                  let fkkey = ["No"];
        
                  let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
          
                  let mydata = Object.assign(jsonitem);
                  let json_data = this.serviceapi.json_readdata(mydata,"1");
          
                
                  this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
                    
                    this.Status = result["Message"];
                    if (this.Status == '1'){
                      
                      let Records = result["Records"];
                      this.inventoryArr = Records;
                      this.inventoryItems = this.inventoryArr;

                      let val2 = JSON.stringify(this.inventoryArr);
                      this.storage.get('inventoryData').then((data) => {
                        let array = [];
                        array.push(val2);
                        this.storage.set('inventoryData', array);                   //store arr arr
                      });

                      let data1:any = null;
                      let data2:any = null;
                      let data3:any = null;
                      if (this.inventoryArr.length >0){
                        if(this.branchArr[0]["POS1_ITEM"] != 0)
                        {
                          data1 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS1_ITEM"]);
                          console.log(data1)
                          if(data1 == null)
                          {
                            this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                            this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                            this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                            this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                            this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                          }
                          else
                          {
                            this.inventory1.ITEM_DESC = data1["ITEM_DESC"];
                            this.inventory1.INVENTORY_ID = data1["INVENTORY_ID"];
                            this.inventory1.SELLING_PRICE = data1["SELLING_PRICE"];
                            this.inventory1.POS_LOCATE = data1["POS_LOCATE"];
                            this.inventory1.POS_COLOR = this.branchArr[0]["POS1_COLOR"];
                          }
                        }
                        else
                        {
                          this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                          this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                          this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                          this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                          this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                        }
                      }
                      if (this.inventoryArr.length >1){
                        if(this.branchArr[0]["POS2_ITEM"] != 0)
                        {
                          data2 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS2_ITEM"]);
                          console.log(data2)
                          if(data2 == null)
                            {
                              this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                              this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                              this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                              this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                              this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                            }
                            else
                            {
                              this.inventory2.ITEM_DESC = data2["ITEM_DESC"];
                              this.inventory2.INVENTORY_ID = data2["INVENTORY_ID"];
                              this.inventory2.SELLING_PRICE = data2["SELLING_PRICE"];
                              this.inventory2.POS_LOCATE = data2["POS_LOCATE"];
                              this.inventory2.POS_COLOR = this.branchArr[0]["POS2_COLOR"];
                            }
                        }
                        else
                        {
                          this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                          this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                          this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                          this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                          this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                        }
                      }
                      if (this.inventoryArr.length >2 ){
                        if(this.branchArr[0]["POS3_ITEM"] != 0)
                        {
                          data3 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS3_ITEM"]);
                          console.log(data3)
                          if(data3 == null)
                          {
                            this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                            this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                            this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                            this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                            this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                          }
                          else
                          {
                            this.inventory3.ITEM_DESC = data3["ITEM_DESC"];
                            this.inventory3.INVENTORY_ID = data3["INVENTORY_ID"];
                            this.inventory3.SELLING_PRICE = data3["SELLING_PRICE"];
                            this.inventory3.POS_LOCATE = data3["POS_LOCATE"];
                            this.inventory3.POS_COLOR = this.branchArr[0]["POS3_COLOR"];
                          }
                        }
                        else
                        {
                          this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                          this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                          this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                          this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                          this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                        }
                      }

                      this.loading.dismiss();
                    }
                    else {
                      this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                      this.loading.dismiss();
                    }
                  }, (err) => {
                    this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                    this.loading.dismiss();
                  });

                }
                else {
                  this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  this.loading.dismiss();
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                this.loading.dismiss();
              });
        }
        else
        {
          console.log("here");
          if(this.userGrpId=="1") {

            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];

            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");

            this.showLoader();
            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.branchArr = Records;
                this.branchItems = this.branchArr;
                this.branchID = this.branchArr[0].BRANCH_ID;
                
                let tbl = ["INVENTORY","INVENTORY"];
                let column = ["BRANCH_ID","INVENTORY_ACTIVE"];
                let value = [this.branchID,"YES"];
        
                let tblkey = ["No"];
                let fktbl = ["No"];
                let fkkey = ["No"];
      
                let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        
                let mydata = Object.assign(jsonitem);
                let json_data = this.serviceapi.json_readdata(mydata,"1");
        
              
                this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
                  
                  this.Status = result["Message"];
                  if (this.Status == '1'){
                    
                    let Records = result["Records"];
                    this.inventoryArr = Records;
                    this.inventoryItems = this.inventoryArr;

                    let val2 = JSON.stringify(this.inventoryArr);
                    this.storage.get('inventoryData').then((data) => {
                      let array = [];
                      array.push(val2);
                      this.storage.set('inventoryData', array);                   //store arr arr
                    });

                    let data1:any = null;
                    let data2:any = null;
                    let data3:any = null;
                    if (this.inventoryArr.length >0){
                      if(this.branchArr[0]["POS1_ITEM"] != 0)
                      {
                        data1 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS1_ITEM"]);
                        console.log(data1)
                        if(data1 == null)
                        {
                          this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                          this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                          this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                          this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                          this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                        }
                        else
                        {
                          this.inventory1.ITEM_DESC = data1["ITEM_DESC"];
                          this.inventory1.INVENTORY_ID = data1["INVENTORY_ID"];
                          this.inventory1.SELLING_PRICE = data1["SELLING_PRICE"];
                          this.inventory1.POS_LOCATE = data1["POS_LOCATE"];
                          this.inventory1.POS_COLOR = this.branchArr[0]["POS1_COLOR"];
                        }
                      }
                      else
                      {
                        this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                        this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                        this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                        this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                        this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                      }
                    }
                    if (this.inventoryArr.length >1){
                      if(this.branchArr[0]["POS2_ITEM"] != 0)
                      {
                        data2 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS2_ITEM"]);
                        console.log(data2)
                        if(data2 == null)
                          {
                            this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                            this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                            this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                            this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                            this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                          }
                          else
                          {
                            this.inventory2.ITEM_DESC = data2["ITEM_DESC"];
                            this.inventory2.INVENTORY_ID = data2["INVENTORY_ID"];
                            this.inventory2.SELLING_PRICE = data2["SELLING_PRICE"];
                            this.inventory2.POS_LOCATE = data2["POS_LOCATE"];
                            this.inventory2.POS_COLOR = this.branchArr[0]["POS2_COLOR"];
                          }
                      }
                      else
                      {
                        this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                        this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                        this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                        this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                        this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                      }
                    }
                    if (this.inventoryArr.length >2 ){
                      if(this.branchArr[0]["POS3_ITEM"] != 0)
                      {
                        data3 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS3_ITEM"]);
                        console.log(data3)
                        if(data3 == null)
                        {
                          this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                          this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                          this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                          this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                          this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                        }
                        else
                        {
                          this.inventory3.ITEM_DESC = data3["ITEM_DESC"];
                          this.inventory3.INVENTORY_ID = data3["INVENTORY_ID"];
                          this.inventory3.SELLING_PRICE = data3["SELLING_PRICE"];
                          this.inventory3.POS_LOCATE = data3["POS_LOCATE"];
                          this.inventory3.POS_COLOR = this.branchArr[0]["POS3_COLOR"];
                        }
                      }
                      else
                      {
                        this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                        this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                        this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                        this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                        this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                      }
                    }

                    this.loading.dismiss();
                  }
                  else {
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                    this.loading.dismiss();
                  }
                }, (err) => {
                  this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                  this.loading.dismiss();
                });
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
              this.loading.dismiss();
            });
          }
        }
      }, (err) => {
        console.log("online offline")
        this.loading.dismiss();
        
        if (this.servicegvariable.InternetConnection == 'Online'){
          this.servicegvariable.InternetConnection = 'Offline';
          let confirm = this.alertCtrl.create({
            title: 'Offline',
            message: 'No internet connection. Transaction will store at local device until internet connection again.',
            buttons: [
              {
                text: 'Confirm',
                handler: () => {
                console.log('Agree clicked');
                this.offlineInit();
                }
              }
            ]
          });
          confirm.present();
        }  
      });
    }
    else {                                              //internet offline
      this.offlineInit();
    }
  }

  offlineInit(){

    this.showLoader();
    this.storage.get('offlineBranchData').then((data) => {
      this.branchID = data;
      
      this.storage.get('branchData').then((data) => {
        this.branchData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
            let data = JSON.parse(this.branchData[i]);
            for (let i=0; i<data.length; i++){
              if (this.branchID == data[i].BRANCH_ID){
                this.branchArr.push(data[i]);
              }
            }
          }
          this.branchItems = this.branchArr;

          this.storage.get('inventoryData').then((data) => {
            this.inventoryData = data;
            if (data && data.length > 0) {
              for (let i=0; i<data.length; i++){
                  
                let data = JSON.parse(this.inventoryData[i]);
                for (let i=0; i<data.length; i++){
                  if (this.branchID == data[i].BRANCH_ID){
                    this.inventoryArr.push(data[i]);
                  }
                }
              }
    
            
              console.log(this.inventoryArr)
              this.inventoryItems = this.inventoryArr;
              let data1:any = null;
              let data2:any = null;
              let data3:any = null;
              if (this.inventoryArr.length >0){
                if(this.branchArr[0]["POS1_ITEM"] != 0)
                {
                  data1 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS1_ITEM"]);
                  console.log(data1)
                  if(data1 == null)
                  {
                    this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                    this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                    this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                    this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                    this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                  }
                  else
                  {
                    this.inventory1.ITEM_DESC = data1["ITEM_DESC"];
                    this.inventory1.INVENTORY_ID = data1["INVENTORY_ID"];
                    this.inventory1.SELLING_PRICE = data1["SELLING_PRICE"];
                    this.inventory1.POS_LOCATE = data1["POS_LOCATE"];
                    this.inventory1.POS_COLOR = this.branchArr[0]["POS1_COLOR"];
                  }
                }
                else
                {
                  this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
                  this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
                  this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
                  this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
                  this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
                }
              }
              if (this.inventoryArr.length >1){
                if(this.branchArr[0]["POS2_ITEM"] != 0)
                {
                  data2 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS2_ITEM"]);
                  console.log(data2)
                  if(data2 == null)
                    {
                      this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                      this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                      this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                      this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                      this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                    }
                    else
                    {
                      this.inventory2.ITEM_DESC = data2["ITEM_DESC"];
                      this.inventory2.INVENTORY_ID = data2["INVENTORY_ID"];
                      this.inventory2.SELLING_PRICE = data2["SELLING_PRICE"];
                      this.inventory2.POS_LOCATE = data2["POS_LOCATE"];
                      this.inventory2.POS_COLOR = this.branchArr[0]["POS2_COLOR"];
                    }
                }
                else
                {
                  this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                  this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                  this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                  this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                  this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
                }
              }
              if (this.inventoryArr.length >2 ){
                if(this.branchArr[0]["POS3_ITEM"] != 0)
                {
                  data3 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS3_ITEM"]);
                  console.log(data3)
                  if(data3 == null)
                  {
                    this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                    this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                    this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                    this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                    this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                  }
                  else
                  {
                    this.inventory3.ITEM_DESC = data3["ITEM_DESC"];
                    this.inventory3.INVENTORY_ID = data3["INVENTORY_ID"];
                    this.inventory3.SELLING_PRICE = data3["SELLING_PRICE"];
                    this.inventory3.POS_LOCATE = data3["POS_LOCATE"];
                    this.inventory3.POS_COLOR = this.branchArr[0]["POS3_COLOR"];
                  }
                }
                else
                {
                  this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
                  this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
                  this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
                  this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
                  this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
                }
              }
      
              this.loading.dismiss();
            }
          });
        }
      });
    });
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad B01SalesPage');
  }

  navToPaymentScreen(){
    //this.navCtrl.setRoot(B01D02SalesPaymentPage);
    if( this.i==0){
      let addToDoAlert = this.alertController.create({
        title:"ERROR",
        message:"Please enter at least 1 item to proceed payment",
        buttons:[
          {
            text:"OK"
          }]
      });
      addToDoAlert.present();
    }

    else{
      console.log(parseFloat(this.cardData.BALANCE));
      /* if(this.so_total_price > parseFloat(this.cardData.BALANCE)){       //disable bring card data to payment page. card balance for chekcing only
        let addToDoAlert = this.alertController.create({
          title:"WARNING",
          message:"Insufficient Fleet card credit for total sales",
          buttons:[
            {
              text: 'Cancel',
              role: 'cancel',
              handler: data => {
                console.log('Cancel clicked');
              }
            },
            {
              text:"CONTINUE",
              handler: data => {
                if (this.salesParam != '2') {
                  this.navCtrl.push(B01D02SalesPaymentPage,
                    { Link: this.item_data, 
                      total_Amount: this.so_total_price, 
                      branch_ID: this.branchID, 
                      salesParam: '1',
                      cardData: this.cardData,
                      PAYMENT_TYPE_ID: this.paymentData.PAYMENT_TYPE_ID
                    });
                }
                else{
                  this.navCtrl.push(B01D02SalesPaymentPage,
                    { Link: this.item_data, 
                      total_Amount: this.so_total_price, 
                      branch_ID: this.branchID, 
                      salesParam: '2',
                      layby_SO_ID: this.Layby_SO_ID,
                      cardData: this.cardData,
                      PAYMENT_TYPE_ID: this.paymentData.PAYMENT_TYPE_ID
                    });
                }
              }
            }]
        });
        addToDoAlert.present();
      }
      else { */
        console.log(this.so_total_price)
        if (this.salesParam != '2') {
          this.navCtrl.push(B01D02SalesPaymentPage,
            { Link: this.item_data, 
              total_Amount: this.so_total_price, 
              branch_ID: this.branchID, 
              salesParam: '1',
/*               cardData: this.cardData,                         //disable bring card data to payment page. card balance for chekcing only
              PAYMENT_TYPE_ID: this.paymentData.PAYMENT_TYPE_ID */
            });
        }
        else{
          this.navCtrl.push(B01D02SalesPaymentPage,
            { Link: this.item_data, 
              total_Amount: this.so_total_price, 
              branch_ID: this.branchID, 
              salesParam: '2',
              layby_SO_ID: this.Layby_SO_ID,
/*               cardData: this.cardData,
              PAYMENT_TYPE_ID: this.paymentData.PAYMENT_TYPE_ID */
            });
        }
//      }
    }
  }

  keypad(value){
    if (value == "back"){
      this.qty_value = this.qty_value.slice(0, -1);
    }
    else{
      this.qty_value += value;
    }
  }

  Descrip(inventory_id,petrol,price,type){
    this.inventroy_id = inventory_id;
    this.oil_type = petrol;
    this.oil_price = price;
    this.inventory_type = type;
    this.overlayHidden = true;
    console.log(this.inventroy_id)
  }

  refresh(){
    this.oil_type="";
    this.oil_quantity="";
    this.oil_price="";
    this.qty_value="";
    
    //console.log(ori_Total);
  }

  enter(){

    var newItem_data ={
      "ID": 0,
      "description" : '',
      "quantity" : '',
      "each" : '',
      "discount_perc" : 0,
      "tax_perc" : '',
      "total_tax" : '',
      "total_sub" : '',
      "sol_total_price" : '',
    };
    this.shortage=0;
    if( +this.qty_value>0 && +this.oil_price>0 ){

      this.total_tax = this.qty_value * this.tax_perc / (this.tax_perc + 100);

      var sub = this.qty_value;
      newItem_data.total_sub = (+sub).toFixed(2);

      this.oil_quantity=(+sub/+this.oil_price).toFixed(2);
      console.log("quantity:", this.oil_quantity);
      //this.checkInventoryLevel(1);

      let oil_quantity = this.oil_quantity;
      let oil_type = this.oil_type;
      let oil_price = this.oil_price;
      let tax_perc = this.tax_perc;
      let total_tax = this.total_tax;
      let qty_value = this.qty_value;

      this.storage.get('inventoryLevelData').then((data) => {
        this.tempLevelData = data;            
        console.log(this.tempLevelData);
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.tempLevelData[i]);
            console.log(data);
            for (let i=0; i<data.length; i++){
              if (this.inventroy_id == data[i].INVENTORY_ID){
                console.log("found inventory")
                console.log("quantity:", oil_quantity, this.inventroy_id);
                if (parseFloat(oil_quantity) > parseFloat(data[i].QUANTITY)){
                  this.shortage=1;
                  let addToDoAlert = this.alertController.create({
                    title:"Insufficient Inventory",
                    message:"This item cannot add to sales.",
                    buttons:[
                      {
                        text:"OK"
                      }]
                  });
                  addToDoAlert.present();
                }
                else if (this.inventory_type == '1' || this.inventory_type == '2'){
                  if (parseFloat(data[i].QUANTITY) < 1000){             //for petrol & diesel, warning when lower than 1000
                    let addToDoAlert = this.alertController.create({
                      title:"Warning",
                      message:"Inventory Low. Please add inventory for this item.",
                      buttons:[
                        {
                          text:"OK"
                        }]
                    });
                    addToDoAlert.present();
                  }
                }
                else if (this.inventory_type == '3'){                   //for gas, warning when lower than 5
                  if (parseFloat(data[i].QUANTITY) < 5){
                    let addToDoAlert = this.alertController.create({
                      title:"Warning",
                      message:"Inventory Low. Please add inventory for this item.",
                      buttons:[
                        {
                          text:"OK"
                        }]
                    });
                    addToDoAlert.present();
                  }
                }
                console.log(this.shortage);
                console.log("quantity:", oil_quantity);
                if (this.shortage==1){
                  this.shortage=0;
                }
                else{
                  newItem_data.quantity = oil_quantity;
                  newItem_data.description = oil_type;
                  newItem_data.each = (+oil_price).toFixed(2);
                  newItem_data.tax_perc = (+tax_perc).toFixed(2);
            
                  newItem_data.total_tax = (+total_tax).toFixed(2);
                  newItem_data.sol_total_price = (+qty_value).toFixed(2);
                  newItem_data.ID = this.inventroy_id;
                  console.log(newItem_data);
                  this.item_data.push(newItem_data); 
                  
                  this.subTotal = 0;
                  let taxTotal = 0;
                  for (this.i = 0; this.i < this.item_data.length; this.i++) {  //loop through the array
                    this.subTotal += +(this.item_data[this.i].total_sub);  //Do the math!
                    taxTotal += +this.item_data[this.i].total_tax;
                  }
                 
                  this.total_sub = Number(this.subTotal);
                  this.so_total_price = Number((this.total_sub).toFixed(2));
                  console.log(this.so_total_price);
                }
              }
            }
          }
        }
      });
      
    }
    else if ( +this.oil_quantity > 0 ){

      let oil_quantity = this.oil_quantity;
      let oil_type = this.oil_type;
      let oil_price = this.oil_price;
      let tax_perc = this.tax_perc;
      let total_tax = this.total_tax;
      let qty_value = this.qty_value;

      this.storage.get('inventoryLevelData').then((data) => {
        this.tempLevelData = data;            
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.tempLevelData[i]);
            for (let i=0; i<data.length; i++){
              if (this.inventroy_id == data[i].INVENTORY_ID){
                console.log("found inventory")
                console.log("quantity:", oil_quantity, this.inventroy_id);
                if (parseFloat(oil_quantity) > parseFloat(data[i].QUANTITY)){
                  this.shortage=1;
                  let addToDoAlert = this.alertController.create({
                    title:"Insufficient Inventory",
                    message:"This item cannot add to sales.",
                    buttons:[
                      {
                        text:"OK"
                      }]
                  });
                  addToDoAlert.present();
                }
                else if (this.inventory_type == '1' || this.inventory_type == '2'){
                  if (parseFloat(data[i].QUANTITY) < 1000){             //for petrol & diesel, warning when lower than 1000
                    let addToDoAlert = this.alertController.create({
                      title:"Warning",
                      message:"Inventory Low. Please add inventory for this item.",
                      buttons:[
                        {
                          text:"OK"
                        }]
                    });
                    addToDoAlert.present();
                  }
                }
                else if (this.inventory_type == '3'){                   //for gas, warning when lower than 5
                  if (parseFloat(data[i].QUANTITY) < 5){
                    let addToDoAlert = this.alertController.create({
                      title:"Warning",
                      message:"Inventory Low. Please add inventory for this item.",
                      buttons:[
                        {
                          text:"OK"
                        }]
                    });
                    addToDoAlert.present();
                  }
                }
                console.log(this.shortage);
                console.log("quantity:", oil_quantity);
                if (this.shortage==1){
                  this.shortage=0;
                }
                else{
                  newItem_data.each = (+oil_price).toFixed(2);
                  newItem_data.quantity = (+oil_quantity).toFixed(2);
                  var sub2 = (+newItem_data.quantity * +newItem_data.each).toFixed(2);
                  newItem_data.total_sub = sub2;
                  newItem_data.description = oil_type;
                  
                  newItem_data.tax_perc = (tax_perc).toFixed(2);

                  total_tax = +sub2 * tax_perc / (tax_perc + 100);
                  qty_value = (+sub2).toFixed(2);

                  newItem_data.total_tax = (total_tax).toFixed(2);
                  newItem_data.sol_total_price = (+qty_value).toFixed(2);
                  newItem_data.ID = this.inventroy_id;

                  console.log(newItem_data);
                  this.item_data.push(newItem_data); 
                  
                  this.subTotal=0;
                  let taxTotal = 0;
                  for (this.i = 0; this.i < this.item_data.length; this.i++) {  //loop through the array
                    this.subTotal += +(this.item_data[this.i].total_sub);  //Do the math!
                    taxTotal += +this.item_data[this.i].total_tax;
                  }
                
                  this.total_sub = Number(this.subTotal);
                  this.so_total_price = Number((this.total_sub).toFixed(2));
                  console.log(this.so_total_price);
                }
              }
            }
          }
        }
      });
    }
    else{
      let addToDoAlert = this.alertController.create({
        title:"ERROR",
        message:"Please enter valid value",
        buttons:[
          {
            text:"OK"
          }]
      });
      addToDoAlert.present();
    }

    this.oil_type="";
    this.oil_quantity="";
    this.oil_price="";
    this.qty_value="";

  }


  /* checkInventoryLevel(type){
    this.storage.get('inventoryLevelData').then((data) => {
      this.tempLevelData = data;            
      if (data && data.length > 0) {
        for (let i=0; i<data.length; i++){
            
          let data = JSON.parse(this.tempLevelData[i]);
          for (let i=0; i<data.length; i++){
            if (this.inventroy_id == data[i].INVENTORY_ID){
              console.log("found inventory")
              if (parseFloat(this.oil_quantity) > parseFloat(data[i].QUANTITY)){
                this.shortage=1;
                let addToDoAlert = this.alertController.create({
                  title:"Insufficient Inventory",
                  message:"This item cannot add to sales.",
                  buttons:[
                    {
                      text:"OK"
                    }]
                });
                addToDoAlert.present();
              }
              else if (this.inventory_type == '1' || this.inventory_type == '2'){
                if (parseFloat(data[i].QUANTITY) < 1000){             //for petrol & diesel, warning when lower than 1000
                  let addToDoAlert = this.alertController.create({
                    title:"Warning",
                    message:"Inventory Low. Please add inventory for this item.",
                    buttons:[
                      {
                        text:"OK"
                      }]
                  });
                  addToDoAlert.present();
                }
              }
              else if (this.inventory_type == '3'){                   //for gas, warning when lower than 5
                if (parseFloat(data[i].QUANTITY) < 5){
                  let addToDoAlert = this.alertController.create({
                    title:"Warning",
                    message:"Inventory Low. Please add inventory for this item.",
                    buttons:[
                      {
                        text:"OK"
                      }]
                  });
                  addToDoAlert.present();
                }
              }
            }
          }
        }
      }
    });
  } */

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });

    this.loading.present();
  }

  showonlineLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Check network status...',
        duration: 5000,
    });
    this.loading.present();
  }

  cancelSales(){
    let confirm = this.alertController.create({
      title: 'Confirmation',
      message: 'Are you sure you want to cancel sales?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
            this.item_data = [];                              //clear sales data
            this.total_tax = 0;
            this.tax_perc = 10;
            this.discount = 0;
            this.so_total_price = 0;
            this.i = 0;
            this.subTotal = 0;
            this.total_sub = 0;
          }
        }
      ]
    });
    confirm.present();
  }

  holdSales(){

    if( this.i==0){                                               //no item
      let addToDoAlert = this.alertController.create({
        title:"ERROR",
        message:"Please enter at least 1 item.",
        buttons:[
          {
            text:"OK"
          }]
      });
      addToDoAlert.present();
    }
    else{
      let tbl = ["USER"];
      let column = ["USER_ID"];
      let value1 = [this.userId];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value1,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");

      this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1"){
          let Records = result["Records"];
          /* this.userRunNo = Records[0]["USER_RUNNO"]; */
        }
      }, (err) => {
      });

      let sol_length = this.item_data.length;

      for (let i=0; i<sol_length; i++){
        this.SOL_JSON(this.item_data[i]);
      }
      
      if (this.userGrpId == '1'){             //if system admin
        this.userBranchId = this.branchID;
      }
      else {
        this.userBranchId = sessionStorage.getItem('userbranchid');
      }
      
      this.DATA_JSON(this.userId, '1', this.wantokCard, this.userBranchId, this.SOL_Array, this.PAYMENT_Array);
      
      let value = this.SUBMIT_JSON(this.userId,this.DATA_Array);
      console.log(value);
      if (this.servicegvariable.InternetConnection == 'Online'){
        this.showLoader();
        this.serviceapi.poslaybydata(value).then((result) => {
          this.Status = result["Message"];
          console.log(this.Status);
          if (this.Status == "1"){
                          
            this.loading.dismiss();
            this.navCtrl.setRoot(B01SalesPage);
          }
          else{
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();

          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
        });
      }
      else{                                                                         //no internet, store local
        localStorage.setItem("local_data_array", JSON.stringify(this.DATA_Array));
        this.navCtrl.setRoot(B01SalesPage);
      }
    }
  }

  SUBMIT_JSON(USERID, DATA)
  {
    let COMPILE_DATA = {
      Param:"",
      UserID: "",
      Total:0,
      Data:[]
    }

    COMPILE_DATA.Param = "1";                         //Param 1
    COMPILE_DATA.UserID = USERID;
    COMPILE_DATA.Total =  (this.DATA_Array).length;
    COMPILE_DATA.Data = DATA;

    return COMPILE_DATA;
  }

  SOL_JSON(SALES)
  {
      let SOL = {	
        SOL_DESC:"",
        QTY:"",
        UNIT_PRICE:"0",
        DISC_PERC:"0",
        TAX_PERC:"0",
        TOTAL_TAX:"0",
        SOL_TOTAL:"0",
        GRAND_SOL_TOTAL:"0",
        INVENTORY_ID:""
      }

      SOL.SOL_DESC = SALES.description;
      SOL.QTY = SALES.quantity;
      SOL.UNIT_PRICE = SALES.each;
      SOL.DISC_PERC = SALES.discount_perc;
      SOL.TAX_PERC = SALES.tax_perc;
      SOL.TOTAL_TAX = SALES.total_tax;
      SOL.SOL_TOTAL = SALES.total_sub;
      SOL.GRAND_SOL_TOTAL = SALES.sol_total_price;
      SOL.INVENTORY_ID = SALES.ID;

      this.SOL_Array.push(SOL)
  }

  DATA_JSON(ACTION_BY, STATUS, WANTOK_CARD, BRANCH_ID, SOL, PAYMENT)
  {
      let DATA = {
				RunNo:0,
				DateTime:"",
				SOL_Total:0,
				Branch_ID:"",
        Card:"",
        Action_By:"",
        Status:"",
        Sales:[],
        Payment:[]
      }
//      this.userRunNo = +this.userRunNo + 1;
      DATA.RunNo = this.userRunNo;
      DATA.DateTime = this.formatDateTime();
      DATA.SOL_Total = (this.SOL_Array).length;
      DATA.Branch_ID = BRANCH_ID;
      DATA.Card = WANTOK_CARD;
      DATA.Action_By = ACTION_BY;
      DATA.Status = STATUS;
      DATA.Sales = SOL;
      DATA.Payment = PAYMENT;

      this.DATA_Array.push(DATA);
      console.log(this.DATA_Array)
  }

  formatDateTime(){
    let date = new Date();
    let sign1 = "-";
    let sign2 = ":";
    let year:any = date.getFullYear() // 年
    let month:any = date.getMonth() + 1; // 月
    let day:any  = date.getDate(); // 日
    let hour:any = date.getHours(); // 时
    let minutes:any = date.getMinutes(); // 分
    let seconds:any = date.getSeconds() //秒

    // 给一位数数据前面加 “0”
    if ((month >= 1) && (month <= 9)) {
      month = '0' + month;
    }
    if ((day >= 0) && (day <= 9)) {
      day = '0' + day;
    }
    if ((hour >= 0) && (hour <= 9)) {
      hour = '0' + hour;
    }
    if ((minutes >= 0) && (minutes <= 9)) {
      minutes = '0' + minutes;
    }
    if ((seconds >= 0) && (seconds <= 9)) {
      seconds = '0' + seconds;
    }
    var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds;
    return currentdate;
  }

  Prompt()
  {
    this.overlayHidden = false;
  }

  hideOverlay()
  {
    this.overlayHidden = true;
  }

  hideOverlay2()
  {
    this.overlayHidden2 = true;
  }

  scanCode(){
    this.barcodeScanner.scan().then(barcodeData => {
      this.cardNo = barcodeData.text;
      this.enterFleetCard();
    }, (err) => {
        console.log('Error: ', err);
    });
  }

  onChangeBranch(data)
  {
    this.errorMessage = '';

    this.item_data = [];                              //clear sales data
    this.total_tax = 0;
    this.tax_perc = 10;
    this.discount = 0;
    this.so_total_price = 0;
    this.i = 0;
    this.subTotal = 0;
    this.total_sub = 0;

    this.inventory1 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};
    this.inventory2 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};
    this.inventory3 = {ITEM_DESC:"",SELLING_PRICE:"",INVENTORY_ID:"",POS_LOCATE:"",POS_COLOR:"#808080"};

    this.showLoader();
    let val = this.branchItems.find(c => c["BRANCH_ID"] === data);
    let branch_id = val["BRANCH_ID"];

   let tbl = ["INVENTORY","INVENTORY"];
    let column = ["BRANCH_ID","INVENTORY_ACTIVE"];
    let value = [this.branchID,"YES"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

  
    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.inventoryArr = Records;
        this.inventoryItems = this.inventoryArr;
        let data1:any = null;
        let data2:any = null;
        let data3:any = null;
        if (this.inventoryArr.length >0){
          if(this.branchArr[0]["POS1_ITEM"] != 0)
          {
            data1 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS1_ITEM"]);
            console.log(data1)
            if(data1 == null)
            {
              this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
              this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
              this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
              this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
              this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
            }
            else
            {
              this.inventory1.ITEM_DESC = data1["ITEM_DESC"];
              this.inventory1.INVENTORY_ID = data1["INVENTORY_ID"];
              this.inventory1.SELLING_PRICE = data1["SELLING_PRICE"];
              this.inventory1.POS_LOCATE = data1["POS_LOCATE"];
              this.inventory1.POS_COLOR = this.branchArr[0]["POS1_COLOR"];
            }
          }
          else
          {
            this.inventory1.ITEM_DESC = this.inventoryItems[0]["ITEM_DESC"];
            this.inventory1.INVENTORY_ID = this.inventoryItems[0]["INVENTORY_ID"];
            this.inventory1.SELLING_PRICE = this.inventoryItems[0]["SELLING_PRICE"];
            this.inventory1.POS_LOCATE = "1";//data1["POS_LOCATE"];
            this.inventory1.POS_COLOR = "#00FF00";//data1["POS_COLOR"];
          }
        }
        if (this.inventoryArr.length >1){
          if(this.branchArr[0]["POS2_ITEM"] != 0)
          {
            data2 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS2_ITEM"]);
            if(data2 == null)
              {
                this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
                this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
                this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
                this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
                this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
              }
              else
              {
                this.inventory2.ITEM_DESC = data2["ITEM_DESC"];
                this.inventory2.INVENTORY_ID = data2["INVENTORY_ID"];
                this.inventory2.SELLING_PRICE = data2["SELLING_PRICE"];
                this.inventory2.POS_LOCATE = data2["POS_LOCATE"];
                this.inventory2.POS_COLOR = this.branchArr[0]["POS2_COLOR"];
              }
          }
          else
          {
            this.inventory2.ITEM_DESC = this.inventoryItems[1]["ITEM_DESC"];
            this.inventory2.INVENTORY_ID = this.inventoryItems[1]["INVENTORY_ID"];
            this.inventory2.SELLING_PRICE = this.inventoryItems[1]["SELLING_PRICE"];
            this.inventory2.POS_LOCATE = "2";//data1["POS_LOCATE"];
            this.inventory2.POS_COLOR = "#CC9900";//data1["POS_COLOR"];
          }
        }
        if (this.inventoryArr.length >2 ){
          if(this.branchArr[0]["POS3_ITEM"] != 0)
          {
            data3 = this.inventoryItems.find(c => c["INVENTORY_ID"] === this.branchArr[0]["POS3_ITEM"]);
            if(data3 == null)
            {
              this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
              this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
              this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
              this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
              this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
            }
            else
            {
              this.inventory3.ITEM_DESC = data3["ITEM_DESC"];
              this.inventory3.INVENTORY_ID = data3["INVENTORY_ID"];
              this.inventory3.SELLING_PRICE = data3["SELLING_PRICE"];
              this.inventory3.POS_LOCATE = data3["POS_LOCATE"];
              this.inventory3.POS_COLOR = this.branchArr[0]["POS3_COLOR"];
            }
          }
          else
          {
            this.inventory3.ITEM_DESC = this.inventoryItems[2]["ITEM_DESC"];
            this.inventory3.INVENTORY_ID = this.inventoryItems[2]["INVENTORY_ID"];
            this.inventory3.SELLING_PRICE = this.inventoryItems[2]["SELLING_PRICE"];
            this.inventory3.POS_LOCATE = "3";//data1["POS_LOCATE"];
            this.inventory3.POS_COLOR = "#000000";//data1["POS_COLOR"];
          }
        }

        this.loading.dismiss();
      }
      else {
        this.errorMessage = 'Branch Selected Do Not have Inventory';
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      this.loading.dismiss();
    });
  }

  checkInternet(){
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];

    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      this.servicegvariable.InternetConnection = "Online";
    }, (err) => {
      this.servicegvariable.InternetConnection = "Offline";
    });
    
  }

  pad_with_zeroes(number, length) {                                   //routine to add 0 infront number

    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }

  cardBalance(){
    this.errorMessage = null;
    this.overlayHidden2 = false;
    this.cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }
  }

  exitFleetCard(){
    this.overlayHidden2 = true;
  }

  enterFleetCard(){

    //disable get online. To keep card data offline 210320
/*     if (this.servicegvariable.InternetConnection == 'Online'){
      
      this.paymentData.PAYMENT_TYPE_ID = '';

      this.errorMessage = null;
      this.cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      let tbl = ["CARD"];
      let column = ["CARD_NO"];
      let value = [this.cardNo];
      
      let tblkey = ["CORP_ID"];
      let fktbl = ["CORPORATE"];
      let fkkey = ["CORP_ID"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      this.showLoader();
      this.serviceapi.readdata(json_data,"CARD","1","1").then((result) => {
        this.Status = result["Message"];

        if (this.Status == "1"){
          let Records = result["Records"];
          this.cardData.CARD_ACTIVE = Records[0]["CARD_ACTIVE"];
          this.cardData.CORP_ACTIVE = Records[0]["CORP_ACTIVE"];
          this.loading.dismiss();

          if (this.cardData.CARD_ACTIVE != "YES")
            this.errorMessage = "Card Not Active.";
          else if (this.cardData.CORP_ACTIVE != "YES")
            this.errorMessage = "Corporate Not Active.";
          else {
            this.paymentData.PAYMENT_TYPE_ID = '3';
            this.cardData.CARD_NO = Records[0]["CARD_NO"];
            this.cardData.CAR_PLATE = Records[0]["CAR_PLATE"];
            this.cardData.CREDIT_LIMIT = Records[0]["CREDIT_LIMIT"];
            this.cardData.BALANCE = Records[0]["BALANCE"];
            this.cardData.CORP_ID = Records[0]["CORP_ID"];
            this.cardData.CORP_NAME = Records[0]["CORP_NAME"];
          }
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          this.loading.dismiss();
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
          this.loading.dismiss();
      });
    }
    else { */
      this.paymentData.PAYMENT_TYPE_ID = '';
      this.errorMessage = null;
      this.cardData =  { CARD_NO:'', CAR_PLATE:'',  CREDIT_LIMIT:'',
                          BALANCE:'', CARD_ACTIVE:'', CORP_ID: '', CORP_NAME:'', CORP_ACTIVE:''
                        }

      this.showLoader();
      this.storage.get('cardData').then((data) => {
        this.tempcardData = data;
        if (data && data.length > 0) {
          for (let i=0; i<data.length; i++){
              
            let data = JSON.parse(this.tempcardData[i]);
            for (let i=0; i<data.length; i++){
              if (this.cardNo == data[i].CARD_NO){
                this.cardData.CARD_ACTIVE = data[i].CARD_ACTIVE;
                this.cardData.CORP_ACTIVE = data[i].CORP_ACTIVE;

                if (this.cardData.CARD_ACTIVE != "YES")
                  this.errorMessage = "Card Not Active.";
                else if (this.cardData.CORP_ACTIVE != "YES")
                  this.errorMessage = "Corporate Not Active.";
                else {
                  this.paymentData.PAYMENT_TYPE_ID = '3';
                  this.cardData.CARD_NO = data[i].CARD_NO;
                  this.cardData.CAR_PLATE = data[i].CAR_PLATE;
                  this.cardData.CREDIT_LIMIT = data[i].CREDIT_LIMIT;
                  this.cardData.BALANCE = data[i].BALANCE;
                  this.cardData.CORP_ID = data[i].CORP_ID;
                  this.cardData.CORP_NAME = data[i].CORP_NAME;
                }
              }
            }
            if (this.errorMessage == null){
              if (this.paymentData.PAYMENT_TYPE_ID == ''){
                this.errorMessage = "Card not found.";
              }
            }

            if (this.errorMessage != null){
              let confirm = this.alertCtrl.create({
                title: 'Error',
                message: this.errorMessage,
                buttons: [
                  {
                    text: 'Confirm',
                    handler: () => {
                    console.log('Agree clicked');
                    }
                  }
                ]
              });
              confirm.present();
            }
            this.cardNo = null;
          }
        }
        this.loading.dismiss();
      });
    
  }

  printLast(){
    this.offlineData();
    
  }

  offlineData(){

    

    this.userId = sessionStorage.getItem('userid');
    this.userName = sessionStorage.getItem('username');
    this.userGrpId = sessionStorage.getItem('usergroupid');
/*       this.item_data = this.navParams.get('Link');

    let sol_length = this.item_data.length;

    for (let i=0; i<sol_length; i++){
      this.SOL_JSON(this.item_data[i]);
    }
*/
    this.userId = sessionStorage.getItem('userid');     //user ID

    /* this.storage.get('userData').then((data) => {
      this.userData = data;
      if (data && data.length > 0) {
        for (let i=0; i<data.length; i++){
            
          let data = JSON.parse(this.userData[i]);
          console.log(data);
          for (let i=0; i<data.length; i++){
            if (this.userId == data[i].USER_ID){

              console.log(this.userRunNo);
            }
          }
        } */
    this.storage.get('paymentTypeData').then((data) => {
      this.paymentTypeData_Print = data;
      if (data && data.length > 0) {
        for (let i=0; i<data.length; i++){
            
          let data = JSON.parse(this.paymentTypeData_Print[i]);
          this.paymentTypeArr_Print = data;
        }
        this.paymentTypeItems_Print = this.paymentTypeArr_Print;

        this.storage.get('offlineBranchData').then((data) => {
          this.userBranchId = data;
          console.log(this.userBranchId);
          this.storage.get('branchData').then((data) => {
            this.branchData = data;
            if (data && data.length > 0) {
              for (let i=0; i<data.length; i++){
                let data = JSON.parse(this.branchData[i]);
                for (let i=0; i<data.length; i++){
                  if (this.userBranchId == data[i].BRANCH_ID){
                    this.companyData.COMPANY =data[i].BRANCH_NAME;
                    this.companyData.ADD1 = data[i].ADDR1;
                    this.companyData.ADD2 = data[i].ADDR2;
                    this.companyData.ADD3 = data[i].ADDR3;
                    this.companyData.CONTACT_NO1 = data[i].CONTACT_NO;
                    this.companyData.EMAIL = data[i].EMAIL;
                  }
                }
              }
  
              this.storage.get('lastSalesData').then((data) => {
                this.lastSalesData = data;
                console.log(this.lastSalesData);
                if (data && data.length > 0) {
          
                    let data = JSON.parse(this.lastSalesData[0]);
          /*                     for (let i=0; i<data.length; i++){
                      console.log(data[i]);
                      
                    } */
                    this.DATA_Array_Print = data[0];
                    this.SOL_Array_Print = this.DATA_Array_Print.Sales;
                    this.PAYMENT_Array_Print = this.DATA_Array_Print.Payment;
                    this.date_Print = this.DATA_Array_Print.DateTime;
                    
                    this.wantokCard_Print = this.DATA_Array_Print.Card;
                    console.log(this.DATA_Array_Print)
                  
                      this.storage.get('lastSaleRunningNo').then((data) => {          //load last SO_NO
                        if (data && data.length > 0) {
                          this.userRunNo_Print = data;
                          console.log(this.userRunNo_Print)
  
                          this.storage.get('lastSaleSO_NO').then((data) => {          //load last SO_NO
                            if (data && data.length > 0) {
                              this.SO_NO_Print = data;
                              console.log(this.SO_NO_Print);
      
                              this.storage.get('lastSale_fleet').then((data) => {          //load last SO_NO
                                this.f_fleetPay = data;

                                console.log('f_fleetPay', this.f_fleetPay);
                                this.printReceipt();
                              }); 
                              
                            }
                            else {
                              let temp = "No last SO";
                              this.SO_NO_Print = temp;
      
                              this.storage.get('lastSale_fleet').then((data) => {          //load last SO_NO
                                this.f_fleetPay = data;

                                console.log('f_fleetPay', this.f_fleetPay);
                                this.printReceipt();
                              }); 
                            }
                          }); 
                        }
                        else {
                          this.userRunNo_Print = 0;
  
                          this.storage.get('lastSaleSO_NO').then((data) => {          //load last SO_NO
                            if (data && data.length > 0) {
                              this.SO_NO_Print = data;
                              console.log(this.SO_NO_Print);
      
                              this.storage.get('lastSale_fleet').then((data) => {          //load last SO_NO
                                this.f_fleetPay = data;

                                console.log('f_fleetPay', this.f_fleetPay);
                                this.printReceipt();
                              }); 
                            }
                            else {
                              let temp = "No last SO";
                              this.SO_NO_Print = temp;
      
                              this.storage.get('lastSale_fleet').then((data) => {          //load last SO_NO
                                this.f_fleetPay = data;

                                console.log('f_fleetPay', this.f_fleetPay);
                                this.printReceipt();
                              }); 
                            }
                          }); 
                        }
                      });

                }
                else {
                  this.alertMessage('No last sales data.')
                }
              });
            }
            else {
              this.alertMessage('No branch data. Please download offline data at login page.')
            }
          });
        });
      }
      else {
        this.alertMessage('No payment type data. Please download offline data at login page.')
      }
    });
  }
/*       else {
        this.alertMessage('No offline data. Please download offline data at login page.')
      }
    }); 
  }*/

  alertMessage(msg){
    let confirm = this.alertCtrl.create({
      title: 'Error',
      message: msg,
      buttons: [
        {
          text: 'Confirm',
          handler: () => {
          console.log('Agree clicked');
          }
        }
      ]
    });
    confirm.present();
  }

  printReceipt() {
    let length1 = this.SOL_Array_Print.length;
    let total_Print = 0;
    let total_tax_Print = 0;
    let grand_total_Print = 0;
    for (let i=0; i<length1; i++ ) {
      total_Print = +total_Print+ +this.SOL_Array_Print[i].SOL_TOTAL;
      total_tax_Print = +total_tax_Print+ +this.SOL_Array_Print[i].TOTAL_TAX;
      grand_total_Print = +grand_total_Print+ +this.SOL_Array_Print[i].GRAND_SOL_TOTAL;
    }

    //this.LOCAL_SO_ID = this.SO_NO_Print;  // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    
    /* if (this.LOCAL_SO_ID.length == '18') {
      var last10 = this.LOCAL_SO_ID.slice(-11);   //"S0025A 0000033667
      var firstID = this.LOCAL_SO_ID.substring(0, 7);
      var runingNo = +parseFloat(last10) + this.userRunNo_Print;
      var runingNo10 = this.pad_with_zeroes(runingNo , 10);
      console.log(this.LOCAL_SO_ID.length, firstID, last10, runingNo10);
      this.LOCAL_SO_ID = firstID + runingNo10;
      console.log(this.LOCAL_SO_ID);
    }
    else  */
    //if (this.LOCAL_SO_ID.toString().length == '19'){
    
    /* [YOW:22/07/2020:CR/MPOS/20-03]:Comment
    if (this.f_fleetPay == 1) {
      var last10 = this.LOCAL_SO_ID.slice(-11);   //"CS0025A 0000033667
      var firstID = this.LOCAL_SO_ID.substring(0, 8);
      var runingNo = +parseFloat(last10) + parseFloat(this.userRunNo_Print);
      var runingNo10 = this.pad_with_zeroes(runingNo , 10);
      console.log(this.LOCAL_SO_ID.toString().length, firstID, last10, runingNo10);
      this.LOCAL_SO_ID = firstID + runingNo10;
      console.log(this.LOCAL_SO_ID);
    }*/

    /* console.log(this.DATA_Array_Print);
    console.log(this.SOL_Array_Print);
    console.log(this.LOCAL_SO_ID) */
    
    if(this.plt.is("core"))
    {
      //console.log("web")
      let company = this.companyData.COMPANY;
      let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
      let contact = this.companyData.CONTACT_NO1;
      let email = this.companyData.EMAIL;
      let date = this.date_Print;
      let username = this.userName;
      
      //let total = this.TOTAL;
      //let total_tax = this.TOTAL_TAX;
      //let grand_total = this.SO.GRAND_TOTAL;
      var mywindow = window.open('', 'RECEIPT', 'height=400,width=600');
      mywindow.document.write('<html><head><title></title>');
      mywindow.document.write('</head><body >');
      mywindow.document.write('<div style="max-width: 500px;margin: auto;text-align:center">');

      mywindow.document.write('<b>'+company+'</b><br>');
      mywindow.document.write(address+'<br>');
      mywindow.document.write('Phone: '+contact+'<br>');
      mywindow.document.write('Email: '+email+'<br>');
      mywindow.document.write('<br><b>'+'RECEIPT'+'</b><br>');
      mywindow.document.write('<br>Username: '+username+'<br>');
      mywindow.document.write('Date: '+date+'<br>');
      
      // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      /*if(this.userRunNo_Print == 0) {
        mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID+'<br>');
      }
      else {
        console.log(this.f_fleetPay)
        if (this.f_fleetPay == 1){
          console.log('this.LOCAL_SO_ID.length')
          mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID +'<br>');
        }
        else {
          mywindow.document.write('Receipt Number: '+this.LOCAL_SO_ID + ' + ' + this.userRunNo_Print+'<br>');
        }
      }*/
      mywindow.document.write('Receipt Number: '+ this.SO_NO_Print +'<br>');  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
      
      mywindow.document.write('<table>');
      mywindow.document.write('<tr><td style="width:250px;text-align:left">'+'Item' + '</td><td style="width:100px;text-align:right">' +'Price'+ '</td><td style="width:100px;text-align:right">'+'Quantity' + '</td><td style="width:100px;text-align:right">' + 'Subtotal' + '</td></tr>');
      let length1 = this.SOL_Array_Print.length;
      for (let i=0; i<length1; i++ ) {
        mywindow.document.write('<tr><td style="width:250px">'+this.SOL_Array_Print[i].SOL_DESC + '</td><td style="width:100px;text-align:right">'+this.SOL_Array_Print[i].UNIT_PRICE + '</td><td style="width:100px;text-align:right">'+this.SOL_Array_Print[i].QTY + '</td><td style="width:100px;text-align:right"> K' + parseFloat(this.SOL_Array_Print[i].SOL_TOTAL).toFixed(2) + '</td></tr>');
      }
      mywindow.document.write('<br><br>');
      
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Subtotal</td><td style="width:100px; text-align:right"> K' +parseFloat(total_Print.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Tax</td><td style="width:100px; text-align:right"> K' +parseFloat(total_tax_Print.toString()).toFixed(2)+'</td></tr>');
      mywindow.document.write('<tr><td style="width:250px"></td><td style="width:100px; text-align:right"></td><td style="width:100px; text-align:right">Total</td><td style="width:100px; text-align:right"> K' +parseFloat(grand_total_Print.toString()).toFixed(2)+'</td></tr></table>');
      //mywindow.document.write('Card No : '+this.translistData.CardNo+'<br>Date    : '+arr[0]+'<br>Time    : '+arr[1]+'<br>Trans ID : '+this.transid+'<br>Amount  : K '+ this.translistData.Amount+'<br>Sold By : '+ this.translistData.UserName);
      mywindow.document.write('<br>'+'---------------------------------------------'+'<br><br>');
      
      mywindow.document.write('<table>');
      let length = this.PAYMENT_Array_Print.length;
      for (let i=0; i<length; i++ ) {
        let lengthPay = this.paymentTypeArr_Print.length;
        for (let j=0; j< lengthPay; j++){
          if (this.PAYMENT_Array_Print[i].PAYMENT_TYPE_ID == this.paymentTypeArr_Print[j].PAYMENT_TYPE_ID){
            this.PAYMENT_Array_Print[i].TYPE = this.paymentTypeArr_Print[j].TYPE;
          }
        }
        if (this.PAYMENT_Array_Print[i].PAYMENT_TYPE_ID != '3'){
          mywindow.document.write('<tr><td style="width:350px">'+this.PAYMENT_Array_Print[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
        }
        else{
          mywindow.document.write('<tr><td style="width:350px">'+this.PAYMENT_Array_Print[i].TYPE + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Card No.: ' +this.PAYMENT_Array_Print[i].CORP_CARD_NO + '</td></tr>');
          mywindow.document.write('<tr><td style="width:350px">'+ 'Company: ' +this.PAYMENT_Array_Print[i].CORP_NAME + '</td></tr>');
        }

        if (this.PAYMENT_Array_Print[i].AMOUNT_CHANGE > 0){
          mywindow.document.write('<tr><td style="width:350px">'+'Change' + '</td><td style="width:150px;text-align:right"> K' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_CHANGE).toFixed(2) + '</td></tr>');
        }
      }
      if (this.wantokCard_Print != ''){
        mywindow.document.write('<tr><td style="width:350px">'+ 'Wantok Card: ' +this.wantokCard_Print + '</td></tr>');
      }

      mywindow.document.write('</table><br><br><b>------ PLEASE COME AGAIN ------</b><br>');
      mywindow.document.write('<div></body></html>'); 

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus();
      mywindow.print();
      mywindow.close();
      this.navCtrl.setRoot(B01SalesPage);
    }
    else
    {
      //console.log("app")
      this.companyInfo = '';
      this.userInfo = '';
      this.receiptInfo = '';
      this.receiptInfo2 = '';
      this.paymentInfo = '';
      this.paymentInfo2 = '';
      this.thankyouInfo = '';
      // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo = '';
      this.s_userInfo = '';
      this.s_receiptInfo = '';
      this.s_receiptInfo2 = '';
      this.s_paymentInfo = '';
      this.s_paymentInfo2 = '';
      this.s_thankyouInfo = '';
      // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added

      let company = this.companyData.COMPANY;
      let address = this.companyData.ADD1 + ', '+ this.companyData.ADD2 + ', '+ this.companyData.ADD3;
      let contact = this.companyData.CONTACT_NO1 
      let email = this.companyData.EMAIL;
      let date = this.date_Print;
      let username = this.userName;

      //let total = this.TOTAL;
      //let total_tax = this.TOTAL_TAX;
      //let grand_total = this.GRAND_TOTAL;
    
      //header
  /*  '\x1b\x61\x01'     center
      '\n'              end of line
      '\x1b\x45\x00'    Bold font OFF
      '\x1b\x45\x01'    Bold font ON
      '\x1b\x4d\x00'    Font type A //normal font
      '\x1b\x4d\x01'    Font type B //small font
      '\x1b\x4d\x02'    Font type C //big font
      '\x1b\x61\x00'    Left justification
      '\x1b\x61\x01'    Centering
      '\x1b\x61\x02'    Right justification
  */

      //print branch info
      this.companyInfo = "\x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n"+
                          "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_companyInfo = "\x1b\x4d\x01 \x1b\x61\x01" + "\n\n"+company+"\n"+address+"\n"+'Phone: '+contact+"\n"+'Email: '+email+"\n"+
                          "\n \x1b\x21\x20 \x1b\x45\x01" + 'RECEIPT' + "\x1b\x45\x00 \x1b\x21\x00 \n\n";

      // [YOW:22/07/2020:CR/MPOS/20-03]:Comment
      /*if(this.userRunNo_Print == 0){
        this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
        // [CXY:31/07/2020:IL/MPOS/20-03]:Added
        this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
      }   
      else {
        //console.log(this.f_fleetPay)
        if (this.f_fleetPay == 1){
          this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+"\n\n";
        }
        else {
          this.userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+'+'+this.userRunNo_Print+"\n\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+this.LOCAL_SO_ID+'+'+this.userRunNo_Print+"\n\n";
        }
      }*/
      // [CXY:17/08/2020:IL/MPOS/20-07]: Modify font size
      this.userInfo += '\x1b\x4d\x01' + 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.SO_NO_Print+"\n\n";  // [YOW:22/07/2020:CR/MPOS/20-03]:Added
      this.s_userInfo += 'User: '+username+"\n"+'Date: '+date+"\n"+'Receipt Number: '+"\n"+this.SO_NO_Print+"\n\n";
      this.userInfo += '\x1b\x4d\x00' + '\x1b\x44\x00' + '\x1b\x44\x10\x18\x22\x25\x00'        //set tab position at 32

      //print SOL
      this.userInfo += '\x1b\x61\x00' + ' ' + 'Item' + '\x09' + 'Price'+ '\x09' + 'Quantity' + '\x09' + '\x09' + 'Subtotal' + "\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_userInfo += '\x1b\x61\x00' + ' ' + 'Item' + '   ' + 'Price' + '\x09' + 'Quantity' + ' \x09' + 'Subtotal' + "\n";
      
      let length1 = this.SOL_Array_Print.length;
      for (let i=0; i<length1; i++ ) {
        if (this.receiptInfo.length < 100) {
          this.receiptInfo += ' ' + this.SOL_Array_Print[i].SOL_DESC + '\x09' + this.SOL_Array_Print[i].UNIT_PRICE + '\x09' + this.SOL_Array_Print[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.SOL_Array_Print[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo += ' ' + this.SOL_Array_Print[i].SOL_DESC + ' ' + this.SOL_Array_Print[i].UNIT_PRICE + ' \x09' + this.SOL_Array_Print[i].QTY + '\x09' + "K" + parseFloat(this.SOL_Array_Print[i].SOL_TOTAL).toFixed(2) + "\n";
        }
        else {
          this.receiptInfo2 += ' ' + this.SOL_Array_Print[i].SOL_DESC + '\x09' + this.SOL_Array_Print[i].UNIT_PRICE + '\x09' + this.SOL_Array_Print[i].QTY + '\x09' + "K" + '\x09' + parseFloat(this.SOL_Array_Print[i].SOL_TOTAL).toFixed(2) + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_receiptInfo2 += ' ' + this.SOL_Array_Print[i].SOL_DESC + ' ' + this.SOL_Array_Print[i].UNIT_PRICE + ' \x09' + this.SOL_Array_Print[i].QTY + '\x09' + "K" + parseFloat(this.SOL_Array_Print[i].SOL_TOTAL).toFixed(2) + "\n";
        }
      }
      this.receiptInfo2 +=   "\n" + " Subtotal:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total_Print.toString()).toFixed(2) + "\n" +
                            " Tax:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(total_tax_Print.toString()).toFixed(2) + "\n" +
                            " Total:" + '\x09\x09\x09' + "K" + '\x09' + parseFloat(grand_total_Print.toString()).toFixed(2) + "\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_receiptInfo2 +=  "\n \x09\x09" + "Subtotal" + ' \x09' + " K" + parseFloat(total_Print.toString()).toFixed(2) + "\n" +
                            "\x09\x09" + "     Tax" + ' \x09' +  " K" + parseFloat(total_tax_Print.toString()).toFixed(2) + "\n" +
                            "\x09\x09" + "   Total" + ' \x09' + " K" + parseFloat(grand_total_Print.toString()).toFixed(2) + "\n";

      this.receiptInfo2 +=   '\x1b\x61\x01' + "\n"+'--------------------'+"\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_receiptInfo2 +=  '\x1b\x61\x01' + "\n"+'--------------------'+"\n";

      this.paymentInfo += '\x1b\x44\x00' + '\x1b\x44\x22\x25\x00';        //set tab position at 32
      //print payment
      let length2 = this.PAYMENT_Array_Print.length;
      for (let i=0; i<length2; i++ ) {
        let lengthPay = this.paymentTypeArr_Print.length;
        for (let j=0; j< lengthPay; j++){
          if (this.PAYMENT_Array_Print[i].PAYMENT_TYPE_ID == this.paymentTypeArr_Print[j].PAYMENT_TYPE_ID){
            this.PAYMENT_Array_Print[i].TYPE = this.paymentTypeArr_Print[j].TYPE;
          }
        }
        if (this.PAYMENT_Array_Print[i].PAYMENT_TYPE_ID != '3'){
          // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
          if(this.PAYMENT_Array[i].PAYMENT_TYPE_ID == '7') {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
              this.paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].WANTOK_GIFT_CARD + "\n";
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.s_paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].WANTOK_GIFT_CARD + "\n";
              // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
              this.paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].WANTOK_GIFT_CARD + "\n";
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              this.s_paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].WANTOK_GIFT_CARD + "\n";
              // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
            }
          }
          // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
          else {
            if (this.paymentInfo.length < 90) {
              this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:31/07/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
            else {
              this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
              // [CXY:31/07/2020:IL/MPOS/20-03]:Added
              this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            }
          }
        }
        else {
          if (this.paymentInfo.length < 90) {
            this.paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].CORP_CARD_NO + "\n";
            this.paymentInfo += ' ' + 'Company: '+ this.PAYMENT_Array_Print[i].CORP_NAME + "\n";
            // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
            this.s_paymentInfo += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo += ' ' + 'Company: '+ this.PAYMENT_Array_Print[i].CORP_NAME + "\n";
            // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
          }
          else{
            this.paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].CORP_CARD_NO + "\n";
            this.paymentInfo2 += ' ' + 'Company: '+ this.PAYMENT_Array_Print[i].CORP_NAME + "\n";
            // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
            this.s_paymentInfo2 += '\x1b\x61\x00' + ' ' + this.PAYMENT_Array_Print[i].TYPE + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_TENDER).toFixed(2) + "\n";
            this.s_paymentInfo2 += ' ' + 'Card No.: ' + this.PAYMENT_Array_Print[i].CORP_CARD_NO + "\n";
            this.s_paymentInfo2 += ' ' + 'Company: '+ this.PAYMENT_Array_Print[i].CORP_NAME + "\n";
            // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
          }
        } 

        if (this.PAYMENT_Array_Print[i].AMOUNT_CHANGE > 0){
          this.thankyouInfo += ' ' + 'Change' + '\x09' + "K" + '\x09' + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_CHANGE).toFixed(2) + "\n";
          // [CXY:31/07/2020:IL/MPOS/20-03]:Added
          this.s_thankyouInfo += ' ' + 'Change' + '\x09\x09' + " K" + parseFloat(this.PAYMENT_Array_Print[i].AMOUNT_CHANGE).toFixed(2) + "\n";
        }
      }
      if (this.wantokCard_Print != ''){
        this.thankyouInfo += ' ' + 'Wantok Card: ' + this.wantokCard_Print + "\n";
        // [CXY:31/07/2020:IL/MPOS/20-03]:Added
        this.s_thankyouInfo += ' \x1b\x61\x00' + 'Wantok Card: ' + this.wantokCard_Print + "\n";
      }
      this.thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n\n\n\n\n\n\n\n\n\n";
      // [CXY:31/07/2020:IL/MPOS/20-03]:Added
      this.s_thankyouInfo +=   '\x1b\x61\x01' + "\n\n------ PLEASE COME AGAIN ------\n\n\n\n";

      //console.log(this.receiptInfo.length, this.receiptInfo2.length)
      //console.log(this.paymentInfo.length, this.paymentInfo2.length)
      this.navCtrl.setRoot(B08PrinterPage,{
        param1: this.companyInfo,
        param2: "1",
        param3: this.userInfo,
        param4: this.receiptInfo,
        param5: this.receiptInfo2,
        param6: this.paymentInfo,
        param7: this.paymentInfo2,
        param8: this.thankyouInfo,
        // START: [CXY:31/07/2020:IL/MPOS/20-03]:Added
        param9: this.s_companyInfo,
        param10: this.s_userInfo,
        param11: this.s_receiptInfo,
        param12: this.s_receiptInfo2,
        param13: this.s_paymentInfo,
        param14: this.s_paymentInfo2,
        param15: this.s_thankyouInfo,
        // END: [CXY:31/07/2020:IL/MPOS/20-03]:Added
      });
    } 
  }
}


// WEBPACK FOOTER //
// ./src/pages/b01-sales/b01-sales.ts